var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSentimentGpt = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#563BCE",
    d: "M21.75 12c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25s9.75 4.365 9.75 9.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBFA",
    d: "M10.5 10.8a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m3.75.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m-4.5 1.95a.45.45 0 0 1 .45-.45h3.6a.45.45 0 1 1 0 .9h-3.6a.45.45 0 0 1-.45-.45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBFA",
    fillRule: "evenodd",
    d: "M5.51 12.45h.514a4.126 4.126 0 0 0 4.101 3.675h3.75a4.126 4.126 0 0 0 4.1-3.675h.515a.937.937 0 1 0 0-.9h-.514a4.125 4.125 0 0 0-4.101-3.675h-3.75a4.126 4.126 0 0 0-4.1 3.675H5.51a.937.937 0 1 0 0 .9m4.615-3.675h3.75a3.225 3.225 0 0 1 0 6.45h-3.75a3.225 3.225 0 0 1 0-6.45",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSentimentGpt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sentiment-gpt.6508c085.svg";